/** @jsx jsx */
import { jsx } from '@emotion/core'
import { PageLoading } from 'components/loading'
import { useHistoricoAtividadeColetivaSaudeQuery } from 'graphql/hooks.generated'
import { IdadeOrigemAtendimento } from 'view/atendimentos/detail/historico/model/model-historico'

import HistoricoNoDetailAvailable from '../../HistoricoNoDetailAvailable'
import HistoricoAtividadeColetivaPanelSaude from './HistoricoAtividadeColetivaPanelSaude'

interface HistoricoAtividadeColetivaPecPanelSaudeProps {
  readonly idAtividadeColetiva: ID
  readonly idadeOrigemAtendimento: IdadeOrigemAtendimento
  readonly cidadaoId: ID
}

export default function HistoricoAtividadeColetivaPecPanelSaude({
  idAtividadeColetiva,
  idadeOrigemAtendimento,
  cidadaoId,
}: HistoricoAtividadeColetivaPecPanelSaudeProps) {
  const {
    data: { atividadeColetiva },
    loading,
  } = useHistoricoAtividadeColetivaSaudeQuery({
    variables: { atividadeColetivaId: idAtividadeColetiva, cidadaoId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!atividadeColetiva) {
    return <HistoricoNoDetailAvailable />
  } else {
    return (
      <HistoricoAtividadeColetivaPanelSaude
        atividadeColetiva={atividadeColetiva}
        idadeOrigemAtendimento={idadeOrigemAtendimento}
        isFonteDadosPec
      />
    )
  }
}
